import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BacklogIdeasListCreateRoute extends Route {
  @service store;
  @service currentUser;

  model() {
    return this.store.createRecord('idea', {
      submitter: this.currentUser._currentUser,
    });
  }
}

export default instrumentRoutePerformance(BacklogIdeasListCreateRoute);
